module.exports = __webpack_public_path__ + "img/home-github-dark.3a34503e.png";